"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.replyWithSortedList = exports.createSortedListResponseSchema = exports.createSortedPaginationQuerySchema = void 0;
const typebox_1 = require("@sinclair/typebox");
const api_1 = require("./api");
const api_2 = require("./api");
const primitives_1 = require("./primitives");
/**
 * Create a query schema for pagination
 *
 * @returns
 */
// Disabled as its a complex return type based
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function createSortedPaginationQuerySchema(properties, sortKeySchema) {
    return typebox_1.Type.Object({
        ...properties,
        sort: typebox_1.Type.Optional(sortKeySchema),
        order: typebox_1.Type.Optional(api_2.SortOrderSchema),
        ...api_2.PaginationQueryFields,
    }, {
        title: "Sorted pagination",
        description: "Defines the pagination, sort field and the order to use in a query",
        additionalProperties: true,
    });
}
exports.createSortedPaginationQuerySchema = createSortedPaginationQuerySchema;
/**
 * Helper function to create a schema response type for List Response
 *
 * @returns
 */
// This is ignored because its a complex generated return type which isn't easy to extract to copy and paste
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function createSortedListResponseSchema(item, sortSchema) {
    return (0, primitives_1.StrictObject)({
        ...api_1.PaginationResponseFields,
        sort: typebox_1.Type.Optional(sortSchema),
        order: typebox_1.Type.Optional(api_2.SortOrderSchema),
        total: api_2.TotalSchema,
        results: typebox_1.Type.Array(item, {
            title: "Results",
            description: "Results which match the query and pagination",
        }),
    });
}
exports.createSortedListResponseSchema = createSortedListResponseSchema;
/**
 * Helper function to construct a list response
 *
 * @param total
 * @param results
 * @param pagination
 * @returns
 */
function replyWithSortedList(total, results, pagination) {
    return {
        total,
        results,
        // Guess if not supplied
        skip: pagination?.skip ?? api_1.DEFAULT_SKIP,
        take: pagination?.take ?? Math.max(results.length, api_1.DEFAULT_TAKE),
        sort: pagination?.sort,
        order: pagination?.order,
    };
}
exports.replyWithSortedList = replyWithSortedList;
